// Copyright (c) 2020 Comsearch, Inc., All rights reserved

import React from 'react'
import { object, string } from 'prop-types'
import InfoItem from './InfoItem'
import SendCorrespondence from './SendCorrespondence'
import { StatusIcon } from './styles'

const ContactInfo = ({ contact, idRoot }) => (
  <div>
    <strong className={'display-block'} style={{ textDecoration: 'underline' }}>
      {'Contact Info'}
    </strong>
    <InfoItem
      id={`${idRoot}-contactCode`}
      label={'Contact Code'}
      value={contact.contactCode} />
    <InfoItem
      id={`${idRoot}-contactStatus`}
      label={'Active'}
      value={(
        <StatusIcon active={contact.contactStatus} />
      )} />
    <InfoItem
      id={`${idRoot}-contactName`}
      label={'Contact Name'}
      value={contact.contactName} />
    <InfoItem
      id={`${idRoot}-jobTitle`}
      label={'Job Title'}
      value={contact.jobTitle} />
    <InfoItem
      id={`${idRoot}-email`}
      label={'Email'}
      value={(
        <a
          href={`mailto:${contact.email}`}
          id={`${idRoot}-email-link`}
          rel={'noopener noreferrer'}
          target={'_blank'}>
          {contact.email}
        </a>
      )} />
    <InfoItem
      id={`${idRoot}-deliveryPreference`}
      label={'Delivery Preference'}
      value={contact.deliveryPreference} />
    <InfoItem
      id={`${idRoot}-sendCorrespondence`}
      label={'Send Correspondence'}
      value={(
        <SendCorrespondence sendCorrespondence={contact.sendCorrespondence} />
      )} />
    <InfoItem
      id={`${idRoot}-protectionAgents`}
      label={'Protection Agent'}
      value={contact.protectionAgents} />
    <InfoItem
      id={`${idRoot}-billCode`}
      label={'Bill Code'}
      value={contact.billCode} />
    <strong>{'Phone'}</strong>
    <div style={{ padding: '0 .5em' }}>
      {
        contact.phone.map((d, i) => (
          <InfoItem
            key={i}
            id={`${idRoot}-${i}-${d.type}`}
            label={d.type}
            value={d.number} />
        ))
      }
    </div>
  </div>
)

ContactInfo.propTypes = {
  contact: object.isRequired,
  idRoot: string.isRequired,
}

export default ContactInfo
